import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { PAGE_ROUTES, TranslationModule } from '@galaxy/crm/static';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { Router, RouterModule } from '@angular/router';
import { CrmBulkImportStepperComponent } from './multi-object-bulk-import/bulk-import-stepper.component';
import { CrmDependencies, CrmInjectionToken } from '@galaxy/crm/static';
import { toSignal } from '@angular/core/rxjs-interop';
import { of } from 'rxjs';

@Component({
  selector: 'crm-bulk-import',
  template: `
    <glxy-page [pagePadding]="true">
      <glxy-page-toolbar>
        <glxy-page-nav>
          <glxy-page-nav-button
            [attr.data-action]="'clicked-back-from-crm-multi-bulk-import'"
            previousPageTitle="{{ previousPageTitle | translate }}"
            [previousPageUrl]="(routePrefix$ | async) + '/' + previousPageUrl"
            [useHistory]="hasImportRecordFeatureFlag()"
          ></glxy-page-nav-button>
        </glxy-page-nav>
        <glxy-page-title>{{ 'BULK_IMPORT.TITLE' | translate }}</glxy-page-title>
      </glxy-page-toolbar>

      <glxy-page-wrapper>
        <crm-bulk-import-stepper
          [previousPageUrl]="previousPageUrl"
          [previousPageObjectType]="previousPageObjectType"
        ></crm-bulk-import-stepper>
      </glxy-page-wrapper>
    </glxy-page>
  `,
  providers: [],
  imports: [CommonModule, TranslationModule, GalaxyPageModule, RouterModule, CrmBulkImportStepperComponent],
})
export class CrmBulkImportComponent {
  PAGE_ROUTES = PAGE_ROUTES;
  routePrefix$ = this.config.routePrefix$;
  previousPageObjectType = '';
  previousPageUrl!: string;
  previousPageTitle!: string;

  protected hasImportRecordFeatureFlag = toSignal(this.config.hasImportRecordFeatureFlag$ || of(false));

  constructor(
    @Inject(CrmInjectionToken) private readonly config: CrmDependencies,
    private router: Router,
  ) {
    const navigation = this.router.getCurrentNavigation();
    if (navigation && navigation.extras.state) {
      this.previousPageObjectType = navigation.extras.state['previousPageObjectType'];
    }
    this.getPreviousPageInfo(this.previousPageObjectType);
  }

  getPreviousPageInfo(previousPageObjectType: string) {
    switch (previousPageObjectType) {
      case 'Company':
        this.previousPageUrl = PAGE_ROUTES.COMPANY.ROOT;
        this.previousPageTitle = 'COMPANY.TITLE';
        break;
      default:
        this.previousPageUrl = PAGE_ROUTES.CONTACT.ROOT;
        this.previousPageTitle = 'CONTACT.TITLE';
        break;
    }
  }
}
